import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const ATVStatusContext = createContext();

export const ATVStatusProvider = ({ children }) => {
  const [atvStatuses, setAtvStatuses] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: LIMIT_DATA_PER_PAGE,
    // tambahkan include jika diperlukan
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchAtvStatuses = useCallback(async () => {
    setAtvStatuses((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/atv-status${queryString}`);
      if (response.success) {
        setAtvStatuses({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setAtvStatuses({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchAtvStatuses();
  }, [fetchAtvStatuses]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = atvStatuses.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <ATVStatusContext.Provider
      value={{
        atvStatuses,
        filterOptions,
        handleSearch,
        refetch: fetchAtvStatuses,
        Pagination,
      }}
    >
      {children}
    </ATVStatusContext.Provider>
  );
};

export const useATVStatus = () => {
  const context = useContext(ATVStatusContext);
  if (!context) {
    throw new Error("useATVStatus must be used within ATVStatusProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/atv-status?search=${inputValue}`);
    if (response.success) {
      return response.data.map((status) => ({
        value: status.id,
        label: status.name,
      }));
    }
    return [];
  };

  return { ...context, fetchOptions };
};
